import React from 'react'

import s from './MessageModal.scss'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

export default props => {
  const { title, body } = props
  return (
    <div
      className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sLay.flex, s.body)}
    >
      <div className={sText.descrip1} style={{ marginBottom: '30px' }}>
        {title}
      </div>
      <div className={cn(sText.descrip4, s.text)} dangerouslySetInnerHTML={{ __html: body }} />
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Modal/MessageModal/MessageModal.jsx